export const chatPermissions = () => {
  //deactivating the default view
  const default_face = document.querySelector(".default-face");
  const user_chat = document.querySelectorAll(".specific-chat");
  const exchange_btn = document.querySelector(".exchange");

  user_chat.forEach((item) => {
    item.addEventListener("click", () => {
      default_face.style.opacity = "0";
      default_face.style.zIndex = "-1";
    });
  });

  //After resizing effects
  const left_container = document.querySelector(".left-part");

  window.addEventListener("resize", () => {
    if (window.innerWidth > 780) {
      left_container.classList.remove("hide-container");
      exchange_btn.style.display = "none";
    } else {
      user_chat.forEach((item) => {
        item.addEventListener("click", () => {
          left_container.classList.add("hide-container");
          exchange_btn.style.display = "block";
        });
      });
    }
  });
  if (window.innerWidth < 780) {
    user_chat.forEach((item) => {
      item.addEventListener("click", () => {
        left_container.classList.add("hide-container");
        exchange_btn.style.display = "block";
      });
    });
  }
  exchange_btn.addEventListener("click", () => {
    left_container.classList.remove("hide-container");
    exchange_btn.style.display = "none";
  });

  //activating mobile options
  const mobile_options = document.querySelector(".options-btn");
  const mobile_options_container = document.querySelector(".mobile-options");
  if (mobile_options) {
    mobile_options.addEventListener("click", () => {
      mobile_options_container.style.display = "block";
    });
  }
  document.addEventListener("mouseup", (e) => {
    if (!mobile_options_container.contains(e.target)) {
      mobile_options_container.style.display = "none";
    }
  });

  // sidebar search
  const search_chat_icon = document.querySelector(".search-chat");
  const search_container = document.querySelector(".search-messages");
  const cancel = document.querySelector(".close-search");

  search_chat_icon.addEventListener("click", function () {
    search_container.classList.add("show");
  });

  cancel.addEventListener("click", function () {
    search_container.classList.remove("show");
  });

  const search_chat_icon1 = document.querySelector(".search-chat1");
  search_chat_icon1.addEventListener("click", function () {
    search_container.classList.add("show");
  });
};
